import { Stack, Box, Typography } from "@mui/material";
import React, {useEffect, useRef, useState } from "react";
import useResponsive from "../../hooks/useResponsive";
import {observer} from "mobx-react-lite";
import appealsStore from '../../store/appealsStore';
import { useTheme } from "@mui/material/styles";
import {
    // DocMsg,
    // LinkMsg,
    // MediaMsg,
    // ReplyMsg,
    Voice,
    TextMsg,
    LogMsg,
    Log,
    Timeline,
} from "./AppealCommentElement";
import ChatHeader from "./Header";
import ChatFooter from "./Footer";

const Conversation = ({ isMobile, menu , comments}) => {
    // const dispatch = useDispatch();
    //
    // const { conversations, current_messages } = useSelector(
    //     (state) => state.conversation.direct_chat
    // );
    // const { room_id } = useSelector((state) => state.app);
    let last_created_on = new Date().setHours(0,0,0,0)
    return (
        <Box p={isMobile ? 1 : 3}>
            <Stack spacing={isMobile ? 1 : 3}>
                {comments.map((el) => {
                    let created_on = new Date(el.created_on).setHours(0,0,0,0)
                    switch (el.content_type) {
                        case "textmsg": {
                            if (created_on > last_created_on) {
                                last_created_on = created_on
                                return <><Timeline date={created_on} /><TextMsg el={el} menu={menu} /></>;
                            }
                            last_created_on = created_on
                            return <TextMsg el={el} menu={menu} />;
                        }
                        
                        case "voice": {
                            if (created_on > last_created_on) {
                                last_created_on = created_on
                                return <><Timeline date={created_on} /><Voice el={el} menu={menu} /></>;
                            }
                            last_created_on = created_on
                            return <Voice el={el} menu={menu} />;
                        }

                        case "logmsg": {
                            if (created_on > last_created_on) {
                                last_created_on = created_on
                                return <><Timeline date={created_on} /><TextMsg el={el} menu={menu} /></>;
                            }
                            last_created_on = created_on
                            return <LogMsg el={el} menu={menu} />;
                        }

                        case "log": {
                            if (created_on > last_created_on) {
                                last_created_on = created_on
                                return <><Timeline date={created_on} /><TextMsg el={el} menu={menu} /></>;
                            }
                            last_created_on = created_on
                            return <Log el={el} menu={menu} />;
                        }
                    }
                })}
            </Stack>
        </Box>
    );
};

const ChatComponent = ({handleOpenSearch}) => {
    // const {store} = useContext(Context);
    // const appealId = store.appealId
    const isMobile = useResponsive("between", "md", "xs", "sm");
    const theme = useTheme();
    const messageListRef = useRef(null);

    useEffect(() => {
        // Scroll to the bottom of the message list when new messages are added
        messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
      }, [appealsStore.appeal]);

    const handleScroll = (event) => {
        const { scrollTop } = event.target;
		if (scrollTop === 0) {
            appealsStore.fetchNextAppealsComment()
        }
    };

    return (
        <Stack
            sx={{ height: "100%"}}
            // height={"100%"}
            // maxHeight={"100vh"}
            // minWidth= {"320px"}
            // idth= isDesktop ? 320 : "100%",
            // width={"calc(100vw - 320px )"}
        >
            {/*  */}
            <ChatHeader
                handleOpenSearch={handleOpenSearch}
                appeal={ appealsStore.appeal }
            />
            <Box
                ref={messageListRef}
                width={"100%"}
                onScroll={handleScroll}
                sx={{
                    position: "relative",
                    flexGrow: 1,
                    overflowY: "scroll",
                    overflowX: "hidden",
                    // height: "100vh",
                    backgroundColor:
                        theme.palette.mode === "light"
                            ? "#F0F4FA"
                            : theme.palette.background,

                    boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
                }}
            >
                {/*<SimpleBarStyle timeout={500} clickOnTrack={false}>*/}
                {appealsStore.appeal.comments ? (
                    <Conversation menu={true} isMobile={isMobile} comments={appealsStore.appeal.comments} />
                ) : (
                    <Typography>Clear</Typography>
                )}   

                {/*</SimpleBarStyle>*/}
            </Box>

            {/*  */}
            <ChatFooter />
        </Stack>
    );
};

export default observer(ChatComponent);

export { Conversation };